<template>
  <FocusTrap>
    <div class="card">

    <div class="card-header header-elements-inline" >
      <h5 class="card-title">HDPE Creation</h5>
      <div class="header-elements">
        <div class="list-icons">

          <a class="list-icons-item" data-action="reload" @click="loadAll"></a>
          <a class="list-icons-item" data-action="remove" @click="closeWindow"></a>
        </div>
      </div>
    </div>

    <div class="card-body">
      <form action="#">

        <div class="form-group row">
          <label class="col-lg-2 col-form-label">Name:</label>
          <div class="col-lg-10">
            <input type="text" class="form-control" placeholder="Enter Item Name here..." maxlength="100" v-if="item" v-model="item.name" autofocus required>
          </div>
        </div>

<!--        <div class="form-group row">-->
<!--          <label class="col-lg-2 col-form-label">Print Name:</label>-->
<!--          <div class="col-lg-10">-->
<!--            <input type="text" class="form-control" placeholder="Enter your print name here..." maxlength="100" v-if="item" v-model="item.p_name">-->
<!--          </div>-->
<!--        </div>-->

        <div class="form-group row">
          <label class="col-lg-2 col-form-label">Brand:</label>
          <div class="col-lg-10">
            <select class="form-control" v-if="item" v-model="item.brand_id">
              <option v-for="brand in brands" v-bind:value="brand.id">
                {{ brand.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-lg-2 col-form-label">Unit of measure:</label>
          <div class="col-lg-4">
            <select class="form-control" disabled>
              <option value="1">Nos</option>
              <option value="2" selected >Kgs</option>
              <option value="3">Mts</option>
            </select>
          </div>

          <label class="col-lg-1 col-form-label">Min Qty:</label>
          <div class="col-lg-2">
            <input type="number" class="form-control text-right" placeholder="min stock qty" min="0" v-if="item" v-model="item.min_qty">
          </div>

          <label class="col-lg-1 col-form-label">Max Qty:</label>
          <div class="col-lg-2">
            <input type="number" class="form-control text-right" placeholder="max stock qty" min="0" v-if="item" v-model="item.max_qty">
          </div>

        </div>

        <!--<div class="form-group row">-->
        <!--<label class="col-lg-2 col-form-label">Purchase Ledger:</label>-->
        <!--<div class="col-lg-4">-->
        <!--<select class="form-control form-control-select2" data-fouc>-->
        <!--<option value="1">Physical Product</option>-->
        <!--<option value="2">Virtual Product</option>-->
        <!--<option value="3">Services</option>-->
        <!--</select>-->
        <!--</div>-->

        <!--<label class="col-lg-1 col-form-label">Sale Ledger:</label>-->
        <!--<div class="col-lg-5">-->
        <!--<select class="form-control form-control-select2" data-fouc>-->
        <!--<option value="1">Physical Product</option>-->
        <!--<option value="2">Virtual Product</option>-->
        <!--<option value="3">Services</option>-->
        <!--</select>-->
        <!--</div>-->
        <!--</div>-->

      </form>
    </div>

    <div class="card-footer">
      <div class="text-right" >
        <button type="button" class="btn btn-primary" @click="saveDocument" >Save<i class="icon-paperplane ml-2"></i></button>
      </div>
    </div>
  </div>
  </FocusTrap>
</template>

<script>
  import {userService} from '@/store/auth-header.js'
  export default {
    name: 'HdpeForm',
    data () {
      return {
        item: {},
        groups: [],
        categories: [],
        brands:[]
      }
    },
    props: {
      myitem: {
        type: Object,
        required: false,
        default: JSON.parse('{"id":0,"status":"Active","type":0,"name":"","group_id":1,"unit_id":1,"brand_id":1,"quality_id":1,"color_id":1,"weight":0,"min_qty":0,"max_qty":0,"group":{"id":1,"name":"","type":0,"status":"Active","hsn":"","nature":0,"unit_id":1,"gstrate":0,"itcrate":0,"unit":{"id":1,"type":0,"name":"","status":"Active","digits":0}},"unit":{"id":1,"type":0,"name":"","status":"Active","digits":0},"quality":{"id":1,"type":0,"name":"","status":"Active","weight":0,"colorcharts":[]},"color":{"id":1,"type":0,"name":"","status":"Active","weight":0,"chart":[]},"brand":{"id":1,"type":1,"name":"Primary","status":"Active"}}')
      }
    },
    beforeMount () {
      this.item = this.myitem; // save props data to itself's data and deal with tms
    },
    component: {

    },
    created () {
      this.$data.item = JSON.parse('{"id":0,"status":"Active","type":0,"name":"","group_id":1,"unit_id":1,"brand_id":1,"quality_id":1,"color_id":1,"weight":0,"min_qty":0,"max_qty":0,"group":{"id":1,"name":"","type":0,"status":"Active","hsn":"","nature":0,"unit_id":1,"gstrate":0,"itcrate":0,"unit":{"id":1,"type":0,"name":"","status":"Active","digits":0}},"unit":{"id":1,"type":0,"name":"","status":"Active","digits":0},"quality":{"id":1,"type":0,"name":"","status":"Active","weight":0,"colorcharts":[]},"color":{"id":1,"type":0,"name":"","status":"Active","weight":0,"chart":[]},"brand":{"id":1,"type":1,"name":"Primary","status":"Active"}}')
    },
    mounted () {
      let self = this;
      $('.form-control-select2').select2()


      self.loadBrands();
      // self.loadCategories();
    },
    methods: {
      closeWindow(){
        this.$emit('hdpe_window_closed');
      },
      clear(){
        this.$data.item = JSON.parse('{"id":0,"status":"Active","type":0,"name":"","group_id":1,"unit_id":1,"brand_id":1,"quality_id":1,"color_id":1,"weight":0,"min_qty":0,"max_qty":0,"group":{"id":1,"name":"","type":0,"status":"Active","hsn":"","nature":0,"unit_id":1,"gstrate":0,"itcrate":0,"unit":{"id":1,"type":0,"name":"","status":"Active","digits":0}},"unit":{"id":1,"type":0,"name":"","status":"Active","digits":0},"quality":{"id":1,"type":0,"name":"","status":"Active","weight":0,"colorcharts":[]},"color":{"id":1,"type":0,"name":"","status":"Active","weight":0,"chart":[]},"brand":{"id":1,"type":1,"name":"Primary","status":"Active"}}')
      },
      loadAll(){
        this.loadBrands();
      },
      loadBrands(){
        const self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        fetch(`${process.env.VUE_APP_ROOT_API}api/brands`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.ok) {
            if(resp.data != null){
              self.$data.brands = resp.data;
            }
          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
        });

      },

      saveDocument(){
        const self = this;


        self.$data.item.type = 'HDPE';
        self.$data.item.unit_id = 2;
        self.$data.item.brand_id = parseInt(self.$data.item.brand_id);
        self.$data.item.group_id = 1;
        self.$data.item.quality_id = 1;
        self.$data.item.color_id = 1;
        self.$data.item.min_qty = parseFloat(self.$data.item.min_qty);
        self.$data.item.max_qty = parseFloat(self.$data.item.max_qty);


        if(self.$data.item.name.trim().length < 1){
          alert("Invalid Name");
          return
        }

        const requestOptions = {
          method:  (self.$data.item.id == 0 ? 'POST' : 'PUT'),
          mode:"cors",
          headers: userService.authHeader(),
          body: JSON.stringify(self.$data.item)
        };


        fetch(`${process.env.VUE_APP_ROOT_API}api/item`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.ok) {
            swal ( { title: "Success!" ,  text: resp.msg, type:  "success"} );

            self.$emit('hdpe_saved', resp.data );

          } else {
            swal ( { title: "Oops!" ,  text: resp.msg, type:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
        });
      }
    }
  }
</script>

<style scoped>
  input:focus {
    background: #feff00;

  }

  textarea:focus {
    background: #feff00;

  }

  select:focus {
    background: #feff00;
  }

  button:focus {
    background: #feff00;
    color: #0a0a0a!important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
</style>
